import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { useApi } from "../../../core/apis";
import { useStores } from "../../../core/stores";
import { FullScreenLoading } from "../../../ui/Loading";
import { BusinessAdminView } from "../BusinessAdminView";
import { BusinessModuleEdit } from "../ui/BusinessModuleEdit";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "CustomerAdminTemplateEdit"
>;

export const BusinessAdminTemplateEditScreen = observer(({ route }: Props) => {
  const customerUid = route.params.customerUid;
  const templateUid = route.params.templateUid;
  const moduleUid = route.params.moduleUid;

  const { businessTemplatesApi } = useApi();
  const { businessTemplatesStore } = useStores();

  const template = businessTemplatesStore.byId.get(templateUid);
  const templateData = template?.data.businessModules.find(
    (module) => module.uid === moduleUid,
  );

  React.useEffect(() => {
    return businessTemplatesApi.watchItem(templateUid);
  }, [templateUid, businessTemplatesApi]);

  if (!template || !templateData) {
    return <FullScreenLoading />;
  }

  return (
    <BusinessAdminView customerUid={customerUid}>
      <BusinessModuleEdit
        moduleData={templateData}
        onSave={(newData) => template.updateBusinessTemplateModule(newData)}
      />
    </BusinessAdminView>
  );
});
